import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

import { CognitoCallback, CognitoUtil, RegistrationUser } from '../cognito/cognito.service';
import { UserRegistrationService } from '../cognito/user-registration.service';

import { SharedModule } from '../shared/shared.module';
import { RegisterService } from './register.service';
import { NavbarService } from '../navbar/navbar.service';

import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.css'],
  providers: [RegisterService, UserRegistrationService, CognitoUtil]
})

export class MRRegisterComponent implements OnInit, CognitoCallback {
  registrationUser: RegistrationUser;

  buttonicon = 'fa right fa-user-plus';
  errorMessage: string = '';
  validationerror: boolean = false;
  passwordmatcherror: boolean = false;
  emailValidationerror = false;
  backenderror: boolean = false;

  active: boolean = false;

  constructor(private regService: RegisterService,
              private router: Router,
              public userRegistration: UserRegistrationService,
              public configs: CognitoUtil,
              public navService: NavbarService) {

  }

  ngOnInit() {
    this.navService.hide();
    this.registrationUser = new RegistrationUser();
  }

  onLogin() {
    this.router.navigate(['/login']);
  }

  onRegister() {
    this.errorMessage = null;
    console.log('Calling onRegister()');
    this.validationerror = false;
    this.backenderror = false;
    this.passwordmatcherror = false;
    this.emailValidationerror = false;

    if (this.active) {
      return;
    }

    if (!this.registrationUser.email || !this.registrationUser.password ||
      !this.registrationUser.confirm || !this.registrationUser.firstname ||
      !this.registrationUser.lastname || !this.registrationUser.phone ||
      !this.registrationUser.company || !this.registrationUser.addinfo) {
      console.error('All fields required');
      this.validationerror = true;
      return;
    }

    if (!this.isEmailAddress(this.registrationUser.email)) {
      console.error('Email address is invalid');
      this.emailValidationerror = true;
      return;
    }

    if (this.registrationUser.password !== this.registrationUser.confirm) {
      console.error('Passwords do not match');
      this.passwordmatcherror = true;
      return;
    }

    this.active = true;

    this.registrationUser.email = this.registrationUser.email.toLowerCase();
    this.registrationUser.planid = '1';

    this.buttonicon = 'fa right fa-spinner fa-pulse';

    this.userRegistration.register(this.registrationUser, this);
  }

  cognitoCallback(message: string, result: any) {
    this.active = false;

    if (message != null) {
      // error
      this.errorMessage = message;
      this.backenderror = true;
      console.log('result: ' + this.errorMessage);
      this.buttonicon = 'fa right fa-user-plus';
    } else {
      // success
      this.regService.register(this.registrationUser)
        .subscribe(
        data => {
          console.log('Redirecting to /registerconfirm with username:', this.registrationUser.email);
          this.router.navigate(['/registerconfirm', this.registrationUser.email]);
        },
        error => {
          this.buttonicon = 'fa right fa-user-plus';
          this.backenderror = true;
          this.errorMessage = <any>error;
          console.error('register() error:', this.errorMessage);
        });
    }
  }


  isEmailAddress(str) {
    let pattern = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
    return pattern.test(str);  // returns a boolean
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/register/register.component.ts